import React from 'react';

interface ChameleonIconProps {
  className?: string;
}

const ChameleonIcon: React.FC<ChameleonIconProps> = ({ className = '' }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 100 100"
      className={className}
    >
      {/* Background */}
      <circle cx="50" cy="50" r="48" fill="#4CAF50" />
      
      {/* Chameleon body */}
      <path d="M70,35 C85,45 85,65 65,75 C55,80 35,80 25,70 C15,60 15,40 30,30 C45,20 60,25 70,35 Z" fill="#2E7D32" />
      
      {/* Chameleon eye */}
      <circle cx="65" cy="40" r="8" fill="white" />
      <circle cx="65" cy="40" r="4" fill="black" />
      <circle cx="63" cy="38" r="2" fill="white" />
      
      {/* Chameleon tail */}
      <path d="M25,70 C15,75 5,85 10,90 C15,95 25,85 30,75" fill="#2E7D32" />
      
      {/* Chameleon crest */}
      <path d="M40,25 C50,15 60,20 65,25" stroke="#2E7D32" strokeWidth="4" fill="none" />
    </svg>
  );
};

export default ChameleonIcon;
